import { Box } from "@mui/material"
import { SectorModal } from "./SectorModal"
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useAPI } from "../../hooks/useAPI";
import { SectorData } from "../../types";
import { useAuth } from "../../assets/contexts/AuthContext";

interface EditSectorProps {
  refetchSectors: () => void;
}

export const EditSector = ({ refetchSectors }: EditSectorProps) => {
  const { sector_id } = useParams();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { fetchData } = useAPI();
  const [sector, setSector] = useState<SectorData>({});
  const isLoading = useRef(false);
  const { isAuthenticated } = useAuth();

  const handleClose = () => {
    setOpen(false);
    navigate('/sectors');
  }

  const handleSave = () => {
    navigate('/sectors');
    refetchSectors();
  }
  
  useEffect(() => {
    if (isAuthenticated && !isLoading.current) {
      isLoading.current = true;

      fetchData(`/sectors/${sector_id}`).then(({ errors, data }) => {
        isLoading.current = false;
        setSector(data);
        setOpen(true);
      }).catch(error => {
        isLoading.current = false;
        console.log(error);
      })
    }
  }, [isAuthenticated, sector_id]);

  return (
    <Box className="edit-sector">
      <SectorModal open={open} handleClose={handleClose} handleSave={handleSave} sector={sector} />
    </Box>
  )
}